module.exports = __webpack_public_path__ + "img/maintenance.26a573c0.gif";